const commonWorksheetMassHeaders = {
    'text':             'Фамилия И.О.',
    'contacts':         'Контакты',
    'working':          'Работа с человеком',
    'status':           'Состояние',
    'sourceforsys':     'Источник поступления с систему',
    'sourceforprj':     'Источник поступления в проект',
    'stageresult':      'Результат этапа',
    'prevStageResults': 'Результат предыдущего этапа',
    'workplace':        'Место работы',
    'position':         'Должность',
    'documents':        'Документы',
    'partsInProject':   'Участвовал в проектах',
    'comment':          'Комментарии',
    'education':        'Образование',
};

export default {
    worksheet: {
        create: 'Запланировать событие',
        scheduleDocument: 'Запланировать ввод',
        createDocument: 'Ввести документ',
        pickDocuments: 'Выбрать документ из БД',
        changePersonState: 'Изменить состояние',
        only_participants_can_create: 'Только участники проекта могут создавать события',
        only_participants_can_change_state: 'Только участники проекта могут изменять состояние',
        headers: {
            'settingsTitle':    'Настройки сводки проектов',
            'title':            'Сводка проекта',
            'text':             'Фамилия И.О.',
            'status':           'Состояние',
            'additionalStatus': 'Доп. состояние',
            'contacts':         'Контакты',
            'working':          'Работа с человеком',
            'partsInProject':   'Участвовал в проектах',
            'sourceForProject': 'Источник поступления в проект',
            'sourceForSys':     'Источник поступления в систему',
            'workplace':        'Место работы',
            'position':         'Должность',
            'documents':        'Документы',
            'comment':          'Комментарии',
            'notes':            'Примечание',
            'education':        'Образование',
            'hrnetnotify':      'Уведомления по HR-сети',
            'sourcecomment':    'Комментарий к источнику поступления в проект'
        },
        title: 'Сводка проекта',
        unsupported: 'Проект находится в состоянии «Запрос», поэтому у него нет сводки.<br> Чтобы у проекта появилась сводка, необходимо в программе Experium перевести проект в состояние «В работе».',
        messages: {
            needEvents: 'Для того чтобы перевести человека на выбранный этап требуется внести следующие документы:',
            personStateChanged: 'Состояние успешно изменено',
        },
    },
    worksheetMass: {
        mass_license: 'У вас нет лицензии «Массовый подбор»',
        create: 'Запланировать событие',
        changePersonState: 'Изменить состояние',
        only_participants_can_create: 'Только участники проекта могут создавать события',
        headers: {
            'settingsTitle': 'Настройки сводки проектов МАП',
            ...commonWorksheetMassHeaders,
        },
        excludedHeaders: {
            ...commonWorksheetMassHeaders,
            stageresult: 'Причина исключения'
        },
        title: 'Сводка проекта',
        unsupported: 'Проект находится в состоянии «Запрос», поэтому у него нет сводки.<br> Чтобы у проекта появилась сводка, необходимо в программе Experium перевести проект в состояние «В работе».',
        stages: 'Этапы',
        changeStage: 'Изменить этап',
        excluded: 'Исключенные',
        toolTips: {
            notParticipant: 'Для просмотра сводки проекта Вы должны быть Ответственным или Соисполнителем'
        },
        messages: {
            emptyEvents: 'Для данного этапа не установлены события',
        },
    },
};
